Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000);
  return this;
};

Date.prototype.ceil = function (coeff) {
  this.setTime(Math.ceil(this.getTime() / coeff) * coeff);
  return this;
};
